import CommonLayout from "layouts/DashboardLayout";
import React, { useEffect } from "react";
import { useParams, useLocation } from "react-router";
import { useDispatch } from "react-redux";
import { getSubTraitById } from "../../../../redux/slices/subtraitSlice";
import AddSubTraitForm from "../createSubTrait";

export default function AddSubTrait() {
  const dispatch = useDispatch();
  const { subtraitSlug = "" } = useParams();
  const location = useLocation()



  const queryParams = new URLSearchParams(location.search);
  const roleTab = queryParams.get('roleTab');

  useEffect(() => {
    if (subtraitSlug) {
      dispatch(getSubTraitById({ slug: subtraitSlug, data: { userType: 'admin', platform: roleTab === null ? 'hemp' : roleTab } }));
    }
  }, [subtraitSlug]);

  return (
    <CommonLayout>
      <AddSubTraitForm />
    </CommonLayout>
  );
}
